module.exports = __webpack_public_path__ + "static/media/uniform_female_back.987b5f02.png";